export default __webpack_public_path__ + "quick-actions-ai-for-finance.5ae8c2b1.svg";